// GG: Keep variant option labels populated even when Minimog's
// disableSelectedVariantDefault clears them. Uses defaultChecked
// for initial value and a MutationObserver to survive async clearing.
(function () {
  function getDefaultValue(picker) {
    var inputs = picker.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].defaultChecked) return inputs[i].value;
    }
    return null;
  }

  function watchPicker(picker) {
    var span = picker.querySelector('.option-label--selected');
    if (!span) return;

    function setValue(val) {
      span.textContent = val;
      span.style.setProperty('display', 'inline', 'important');
    }

    // Set initial value using defaultChecked (survives JS unchecking)
    var initialVal = getDefaultValue(picker);
    if (initialVal) setValue(initialVal);

    // Re-set when Minimog's disableSelectedVariantDefault clears the span
    var obs = new MutationObserver(function () {
      if (!span.textContent) {
        var val = getDefaultValue(picker);
        if (val) setValue(val);
      }
    });
    obs.observe(span, { childList: true, characterData: true, subtree: true });

    // Update when user selects a variant button
    picker.addEventListener('change', function () {
      setTimeout(function () {
        var checked = picker.querySelector('input[type="radio"]:checked');
        if (checked) setValue(checked.value);
      }, 0);
    });
  }

  function init() {
    document.querySelectorAll('[data-picker-field="radio"]').forEach(watchPicker);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
